// @flow
import Cookies from "js-cookie";

const CSRF_TOKEN = Cookies.get("csrftoken");

export function csrfFetch(url: string, opts: ?Object): Promise<Response> {
  var headers = {};
  if (opts && opts.headers) {
    headers = opts.headers;
  }

  return fetch(
    url,
    Object.assign({}, opts, {
      credentials: "same-origin",
      headers: Object.assign({ "X-CSRFToken": CSRF_TOKEN }, headers)
    })
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/utils/fetch.js